/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = require('../utils/key_mirror');

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    PUSH_ALERT: null,
    CLEAR_ALERT: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/action_types/alerts.js
// module id = 1182
// module chunks = 60